import React from 'react';
import ReactDOM from 'react-dom';
import {pdfjs} from 'react-pdf';
import {ThemeProvider, CSSReset} from '@chakra-ui/core';
import * as Sentry from '@sentry/react';
import 'styles/index.css';
import theme from 'theme';
import App from 'App';
import { StateMachineProvider, createStore } from 'little-state-machine';

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: 'https://412e700ff9b1466e88877f588910f9b6@o326633.ingest.sentry.io/4504009225535488',
	});
}

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;

createStore(
	{
		form: { excavator_operating_weight: "" },
		calculatedValues : {},
		clientDetails: {}
	}
);

ReactDOM.render(
	<ThemeProvider theme={theme}>
		<CSSReset />
		<StateMachineProvider>
			<App />
		</StateMachineProvider>
	</ThemeProvider>,
	document.getElementById('root'),
);
